import React, { useState, useEffect } from 'react';
import './index.css';
import { Popup } from '../popup/index';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select2 from 'react-select2-wrapper';
import 'select2/dist/css/select2.min.css';
import { UTILS } from '../../../src/constants/index';
import { useSelector } from 'react-redux';

export const AddCard = ({
  column,
  client,
  fetchUpdateCards,
  selectTeamId,
  department,
}) => {
  const userData = JSON.parse(localStorage.getItem('userDetails'));

  let [openCard, setOpenCard] = useState(false);
  const [formData, setFormData] = useState({
    client_id: '',
    title: '',
  });
  const [brandId, setBrandId] = useState(0);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleClientChange = (e) => {
    setFormData({
      ...formData,
      client_id: e.target.value,
    });
  };
  const validateFunc = () => {
    if (formData.client_id == '' || formData.title == '') {
      toast.warning('Fill Out Required Filled');
    } else if (selectTeamId == null || selectTeamId == 0) {
      toast.warning('Please Join any team to continue');
    }
  };
  let getUserId = JSON.parse(localStorage.getItem('userDetails')) || {};
  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!formData.client_id) {
      alert('Select User');
      return;
    }
    const randomString = Math.random().toString(36).substring(2, 5);


    const url =
      UTILS.API_url + `board/v1/board-list-cards/store?${randomString}`;
    const data = new FormData();
    data.append('board_list_id', brandId);
    data.append('user_id', getUserId?.id);
    data.append('client_id', formData.client_id);
    data.append('title', formData.title);
    data.append(
      'team_key',
      Number(selectTeamId) === 0 ? userData.team_key : Number(selectTeamId)
    );

    try {
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status == 201) {
        fetchUpdateCards();
        setFormData({
          client_id: '',
          title: '',
        });
        setOpenCard(false);
        // socket.send(JSON.stringify({ type: 'message', department: department, team: selectTeamId,text:'Transfer' }));
        toast.success('Successfully Added');
      }
    } catch (error) {
      toast.error(error.response.data.errors.client_id[0]);
      console.error("Error:", error.response.data.errors.client_id[0]);
    }
  };

  console.log(selectTeamId);
  

  return (
    <div className="add_card_section">
      {openCard ? (
        <form onSubmit={handleSubmit}>
          <div className="selected_option">

            <div className="selected_option">
              <div>
                <label>Select Client</label>
                <Select2
                  name="client_id"
                  value={formData.client_id}
                  onChange={handleClientChange}
                  data={client.map((client) => ({
                    id: client.id,
                    text: client.combine,
                    value: client.id,
                  }))}
                  options={{
                    placeholder: 'Select an option',
                    allowClear: true,
                  }}
                  required
                />
              </div>
            </div>
            <div>
              <input
                type="text"
                className="input_text"
                placeholder="Enter a title for a card"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>
            <div className="btn_section">
              <button
                className="add_new_card"
                onClick={() => {
                  setBrandId(column.id);
                  validateFunc();
                }}
              >
                Add Card
              </button>
              <div
                className="btn_cross"
                style={{ cursor: 'pointer' }}
                onClick={() => setOpenCard(false)}
              >
                x
              </div>
            </div>
          </div>
        </form>
      ) : (
        <button className="btn_add_card" onClick={() => setOpenCard(true)}>
          + Add a Card
        </button>
      )}
    </div>
  );
};